"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _customiserTypes;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/*
|| THE BELOW VARIABLES ARE USE IN EVERY INSTANCE OF THE CUSTOMIZER
|| productForm - intialized at the top level for scoping purposes, but defined based on context (see handleCustomizer() and loadOffShelfCustomizer() for more details)
|| customiserTypeSettings - takes the dataset attributes from theme.liquid and creates an object stored on customiserTypes
|| yetiTargetSelector - defines the div to inject the customizer UI into
|| yetiCustLocale - takes the customizer locale from a dataset attribute in theme.liquid (see markets metafields for admin data source)
|| galleryDefinitions - Creates array of gallery definitions from dataset attribute in theme.liquid
*/

var productForm;
var customiserTypeSettings = Object.assign({}, document.querySelector('#CustomiserTypeSettings').dataset);
var customizerVersion = document.querySelector('#CustomiserTypeSettings').dataset.customizerVersion;
var boolString = "true";
var customiserTypes = (_customiserTypes = {
  allowTwoSidedEngraving: customiserTypeSettings.allowtwosidedengraving == boolString,
  allowAutoImageUpload: customiserTypeSettings.allowautoimageupload == boolString,
  allowPreparedLogos: customiserTypeSettings.allowpreparedlogos == boolString,
  allowLicensedLogos: customiserTypeSettings.allowlicensedlogos == boolString,
  allowMonogram: customiserTypeSettings.allowmonogram == boolString,
  allowText: customiserTypeSettings.allowtext == boolString,
  allowInternalLogos: customiserTypeSettings.allowinternallogos == boolString,
  allowComplexUpload: customiserTypeSettings.allowcomplexupload == boolString,
  allowLaserReadyUpload: customiserTypeSettings.allowlaserreadyupload == boolString,
  allowCustomColor: customiserTypeSettings.allowcustomcolor == boolString,
  enableTextModeration: customiserTypeSettings.enabletextmoderation == boolString,
  enableImageModeration: customiserTypeSettings.enableimagemoderation == boolString
}, _defineProperty(_customiserTypes, "enableImageModeration", customiserTypeSettings.enableimagemoderation == boolString), _defineProperty(_customiserTypes, "allowLaserReadyUpload", false), _defineProperty(_customiserTypes, "allowComplexUpload", false), _customiserTypes);
var yetiTargetSelector = 'product-customizer';
var yetiCustLocale = document.querySelector('#CustomiserTypeSettings').dataset.customizerLocale;
var galleryDefinitions = document.querySelector("#".concat(yetiTargetSelector)).dataset.galleryDefinition ? document.querySelector("#".concat(yetiTargetSelector)).dataset.galleryDefinition.split(',') : '';

/*
|| THE BELOW VARIABLES ARE USED SOLELY FOR THE OFF-SHELF CUSTOMIZATION FUNCTIONALITY
|| offShelfArray - defines an empty array to push JSON objects to, these JSON objects pre-load customizer UI's engraving choices
|| placeholderCustomizerData - defines an object with placeholder value, some are updated based on url params when arriving from an off-shelf-card to the PDP
|| isPdp - uses window.location.href to determine if page is a PDP
|| params - takes URL search params
|| hasOffShelfParams - Checks whether off-shelf-cust as a param is present
|| hasFrontDesign - checks whether the off-shelf-gallery-front-type param is present, this denotes a front side off the shelf customization needs to be loaded
|| hasBackDesign - checks whether the off-shelf-gallery-back-type param is present, this denotes a back side off the shelf customization needs to be loaded
*/

var offShelfArray = [];
var placeholderCustomizerData = {
  "version": "".concat(customizerVersion),
  "customtype": "prepared",
  "location": "",
  // Value needs populating e.g: front
  "productkey": "",
  // Value needs populating e.g: rambler-tumbler-10oz-white
  "productsku": 0,
  // Value needs populating e.g: 37000001232
  "position": "auto",
  "orientation": 0,
  "scale": 1,
  "width": 1050,
  "height": 1500,
  "embid": "63730ef1-af9e-46d4-a58f-1d8c36d9b0ce",
  "corrid": "9b69ef6b-979f-43d8-8509-deaa4149c1e2",
  "sessionid": "6ecd082f-35a4-41e4-bfed-9e8b8868de95",
  "svg": "",
  // Value needs populating e.g: https://yeti-custom-gallery.imgix.net/svg/taurus.svg
  "centeroffsetx": 525,
  "centeroffsety": 751,
  "approved": true,
  "locale": "en-GB",
  "agreedtoterms": false,
  "agreedtoselfcertify": false,
  "custpreview": "",
  // Value needs populating e.g: https://yeti-custom-gallery.imgix.net/svg/taurus.svg
  "productpreview": "",
  // Value needs populating e.g: https://yeti-customops-gallery.imgix.net/standard/zodiac/taurus/rambler-tumbler-10oz-white/approval-front.png
  "laserimage": "",
  // Value needs populating e.g: https://yeti-custom-gallery.imgix.net/bmp/taurus/rambler-tumbler-10oz-white/front.bmp
  "sku": 0,
  // Value needs populating e.g: 37000001232
  "displayname": "",
  // Value needs populating e.g: 'Taurus'
  "prepared": {
    "key": "",
    // Value needs populating e.g: /standard/zodiac/taurus
    "premium": false,
    "category": "",
    // Value needs populating e.g: zodiac
    "org": null,
    "color": null,
    "light": null,
    "colorname": null
  },
  "warpedpreview": "" // Value needs populating e.g: https://yeti-customops-gallery.imgix.net/standard/zodiac/taurus/rambler-tumbler-10oz-white/approval-front.png
};

var isPdp = window.location.pathname.includes('/products/');
var params = new URL(window.location.href).searchParams;
var hasOffShelfParams = Boolean(params.get('off-shelf-cust'));
var hasFrontDesign = Boolean(params.get('off-shelf-gallery-front-type'));
var hasBackDesign = Boolean(params.get('off-shelf-gallery-back-type'));

/*
|| THE BELOW METHODS ARE FOR FETCHING REQUIRED DATA POINTS TO REPLACE PLACEHOLDER VALUES, AND INTIALISING THE OFF SHELF CUSTOMIZER UI
||
|| fetchOffShelfData()
||      args: offShelfObject {Object}, location {String}
||      This method calls the customizer API for specific data points like centeroffsety and svg url's
||
|| loadOffShelfCustomizer()
||      args: none
||      This method intialises the customizer with the required data objects from the offShelfArray provided in the data property under the options object
||      This method calls the handleApprove() method when customer approves the customization, this is done in the API's onApprove() callback method
||      Following the handleApprove() method execution the params are stripped and window history updated
||
|| handleParams()
||      args: none
||      Checks the hasFrontDesign variable, and creates a structuredClone of the placeholderCustomizerData object,
||      This object is then passed into the fetchOffShelfData() method as the offShelfObject arg, a string denoting the location as 'front' is passed as the location arg
||      Checks the hasBackDesign variable, and creates a structuredClone of the placeholderCustomizerData object,
||      This object is then passed into the fetchOffShelfData() method as the offShelfObject arg, a string denoting the location as 'back' is passed as the location arg
*/
function fetchOffShelfData(_x, _x2) {
  return _fetchOffShelfData.apply(this, arguments);
}
function _fetchOffShelfData() {
  _fetchOffShelfData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(offShelfObject, location) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetch("https://customops-us-east1.yeti.com/api/v1/prepared/data?product=".concat(params.get('product-key'), "&design=/").concat(params.get("off-shelf-gallery-".concat(location, "-type")), "/").concat(params.get("off-shelf-gallery-".concat(location, "-category")), "/").concat(params.get("off-shelf-gallery-".concat(location, "-handle")), "&location=").concat(params.get("off-shelf-".concat(location, "-location"))), {
              method: "GET"
            }).then( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(response) {
                var _offShelfObject$prepa;
                var data;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return response.json();
                      case 2:
                        data = _context3.sent;
                        offShelfObject.location = "".concat(params.get("off-shelf-".concat(location, "-location")));
                        offShelfObject.productkey = params.get('product-key');
                        offShelfObject.productsku = Number(params.get('sku'));
                        offShelfObject.width = data.width;
                        offShelfObject.height = data.height;
                        offShelfObject.svg = data.svg.url;
                        offShelfObject.centeroffsety = data.position.centerOffsetY;
                        offShelfObject.custpreview = data.svg.url;
                        offShelfObject.productpreview = data.preview;
                        offShelfObject.laserimage = data.lra.url;
                        offShelfObject.sku = Number(params.get('sku'));
                        offShelfObject.warpedpreview = data.preview;
                        offShelfObject.displayname = params.get("off-shelf-gallery-".concat(location, "-handle"));
                        offShelfObject.prepared = {
                          "key": "".concat(params.get("off-shelf-gallery-".concat(location, "-type")), "/").concat(params.get("off-shelf-gallery-".concat(location, "-category")), "/").concat(params.get("off-shelf-gallery-".concat(location, "-handle"))),
                          "category": "".concat(params.get("off-shelf-gallery-".concat(location, "-category"))),
                          "org": "null",
                          "color": "null",
                          "light": "null",
                          "colorname": "null",
                          "premium": offShelfObject === null || offShelfObject === void 0 ? void 0 : (_offShelfObject$prepa = offShelfObject.prepared) === null || _offShelfObject$prepa === void 0 ? void 0 : _offShelfObject$prepa.premium
                        };
                        offShelfArray.push(JSON.stringify(offShelfObject));
                      case 18:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));
              return function (_x9) {
                return _ref.apply(this, arguments);
              };
            }());
          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchOffShelfData.apply(this, arguments);
}
function loadOffShelfCustomizer() {
  productForm = document.querySelector('product-form');
  var prodVariants = JSON.parse(document.querySelector('.product__info-container colour-sibling').querySelector(".json__colour_siblings").innerText);
  var prodVariantsWithInventory = prodVariants.filter(function (variant) {
    return variant.available === 'true';
  });
  var enabledVariants = prodVariantsWithInventory.filter(function (variant) {
    return variant['enabled_d2c'] === "true";
  });
  var customisableVariants = [];
  enabledVariants.forEach(function (variant) {
    var _variant$variants$;
    customisableVariants.push({
      "key": "".concat(variant === null || variant === void 0 ? void 0 : variant.customizer_upk),
      "color": "".concat(variant === null || variant === void 0 ? void 0 : (_variant$variants$ = variant.variants[0]) === null || _variant$variants$ === void 0 ? void 0 : _variant$variants$.variant_title),
      "name": "".concat(variant === null || variant === void 0 ? void 0 : variant.product_title)
    });
  });
  var initCustObj = {
    handle: params.get('product-key'),
    id: document.querySelector('product-form input[name="id"]').value,
    prodVariants: prodVariants,
    customisableVariants: customisableVariants,
    customiserTypeSettings: customiserTypeSettings
  };
  YETI.customizer.init({
    selector: "#".concat(yetiTargetSelector),
    // required
    product: params.get('product-key'),
    locale: "".concat(yetiCustLocale),
    showColorSwatch: true,
    data: offShelfArray,
    availableProducts: customisableVariants,
    availableCategories: galleryDefinitions,
    allowTwoSidedDrinkware: customiserTypes.allowTwoSidedEngraving,
    allowAutoImageUpload: customiserTypes.allowAutoImageUpload,
    allowMonogram: customiserTypes.allowMonogram,
    allowText: customiserTypes.allowText,
    allowPreparedLogos: customiserTypes.allowPreparedLogos,
    allowLicensedLogos: customiserTypes.allowLicensedLogos,
    enableTextModeration: customiserTypes.enableTextModeration,
    enableImageModeration: customiserTypes.enableImageModeration,
    showBannerMessage: false,
    showDesignTypePricing: false,
    showPreparedLogoPricing: false,
    onReady: function onReady() {
      var categories = YETI.customizer.getCategories();
    },
    onEvent: function onEvent(event) {
      var eventData = {
        "event_name": "".concat(event),
        "product": "".concat(params.get('productkey')),
        "section_name": "Customizer UI",
        "page_type": "".concat(window.location.pathname.includes('/products/') ? 'PDP' : 'PLP')
      };
      Shopify.analytics.publish('customizer_action', eventData);
    },
    openOnReady: true,
    // optionally open the Customizer UI upon intialization
    onApprove: function () {
      var _onApprove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data, quantity) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return handleApprove(data, quantity, initCustObj).then(function () {
                  var newHistory = window.location.href;
                  newHistory = newHistory.split('?')[0];
                  window.history.pushState(null, '', newHistory);
                });
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function onApprove(_x3, _x4) {
        return _onApprove.apply(this, arguments);
      }
      return onApprove;
    }()
  });
}
function handleParams() {
  return _handleParams.apply(this, arguments);
}
/*
|| THE BELOW CODE BLOCK IS THE STARTING POINT FOR EXECUTING OFF SHELF CUSTOMIZER ON THE PDP
|| if checks for offShelfParams, if found handleParams() is called, and then following this execution
|| loadOffShelfCustomizer() is fired to intiate and display the customizer with pre-loaded data
*/
function _handleParams() {
  _handleParams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var frontObject, backObject;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!hasFrontDesign) {
              _context5.next = 4;
              break;
            }
            frontObject = structuredClone(placeholderCustomizerData);
            _context5.next = 4;
            return fetchOffShelfData(frontObject, 'front');
          case 4:
            if (!hasBackDesign) {
              _context5.next = 8;
              break;
            }
            backObject = structuredClone(placeholderCustomizerData);
            _context5.next = 8;
            return fetchOffShelfData(backObject, 'back');
          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _handleParams.apply(this, arguments);
}
if (hasOffShelfParams) {
  handleParams().then(function () {
    loadOffShelfCustomizer();
  });
}

/*
|| THE BELOW METHOD IS USED FOR GENERIC CUSTOMIZATION INITIATED BY THE USER CLICKING A CUSTOMIZE/PERSONALISE BUTTON ON PLP OR PDP
||
|| It defines the relevent productForm custom element, assorts available customised variants and initializes the customizer with
|| galleries and options defined in the global variables at the top of the file
|| It uses the customizer API's onApprove() callback method to call handleApprove()
*/

function handleCustomizer(e) {
  e.preventDefault();
  productForm = e.currentTarget.dataset.usage === 'quick-add' ? e.currentTarget.closest('quick-add').querySelector('product-form') : e.currentTarget.closest('product-atc').querySelector('product-form');
  if (e.currentTarget.classList.contains("disabled")) {
    return;
  }

  // Sets initialised variables for Customizer
  var currentQty = e.currentTarget.dataset.usage === 'quick-add' ? e.currentTarget.closest('quick-add').querySelector('quantity-input input').value : e.currentTarget.closest('product-atc').querySelector('quantity-input input').value;
  var handle = e.currentTarget.dataset.handle;
  var id = e.currentTarget.dataset.id;
  var prodVariants = e.currentTarget.dataset.usage === 'quick-add' ? JSON.parse(e.currentTarget.closest('quick-add').querySelector(".json__colour_siblings").innerText) : JSON.parse(document.querySelector('.product__info-container colour-sibling').querySelector(".json__colour_siblings").innerText);
  var prodVariantsWithInventory = prodVariants.filter(function (variant) {
    return variant.available === 'true';
  });
  var enabledVariants = prodVariantsWithInventory.filter(function (variant) {
    return variant['enabled_d2c'] === "true";
  });
  var customisableVariants = [];
  enabledVariants.forEach(function (variant) {
    var _variant$variants$2;
    customisableVariants.push({
      "key": "".concat(variant === null || variant === void 0 ? void 0 : variant.customizer_upk),
      "color": "".concat(variant === null || variant === void 0 ? void 0 : (_variant$variants$2 = variant.variants[0]) === null || _variant$variants$2 === void 0 ? void 0 : _variant$variants$2.variant_title),
      "name": "".concat(variant === null || variant === void 0 ? void 0 : variant.product_title)
    });
  });
  // Initial Variables stored in an object for cleaner passing to handleApprove Fn
  var initCustObj = {
    handle: handle,
    id: id,
    prodVariants: prodVariants,
    customisableVariants: customisableVariants,
    customiserTypeSettings: customiserTypeSettings,
    quantity: currentQty
  };

  // Initialises customizer, declares target selector and customizable variants as well as approval callback Fn "handleApprove"
  YETI.customizer.init({
    selector: "#".concat(yetiTargetSelector),
    // required
    product: handle,
    locale: "".concat(yetiCustLocale),
    showColorSwatch: true,
    availableProducts: customisableVariants,
    availableCategories: galleryDefinitions,
    allowTwoSidedDrinkware: customiserTypes.allowTwoSidedEngraving,
    allowAutoImageUpload: customiserTypes.allowAutoImageUpload,
    allowMonogram: customiserTypes.allowMonogram,
    allowText: customiserTypes.allowText,
    allowPreparedLogos: customiserTypes.allowPreparedLogos,
    allowLicensedLogos: customiserTypes.allowLicensedLogos,
    enableTextModeration: customiserTypes.enableTextModeration,
    enableImageModeration: customiserTypes.enableImageModeration,
    showBannerMessage: false,
    environment: "b2b",
    // allowInternalLogos: customiserTypes.allowInternalLogos,
    // allowComplexUpload: customiserTypes.allowComplexUpload,
    // allowLaserReadyUpload: customiserTypes.allowLaserReadyUpload,
    // allowCustomColor: customiserTypes.allowCustomColor,
    showDesignTypePricing: false,
    showPreparedLogoPricing: false,
    allowLaserReadyUpload: false,
    allowComplexUpload: false,
    onReady: function onReady() {
      var categories = YETI.customizer.getCategories();
    },
    onEvent: function onEvent(event) {
      var eventData = {
        "event_name": "".concat(event),
        "product": "".concat(handle),
        "section_name": "Customizer UI",
        "page_type": "".concat(window.location.pathname.includes('/products/') ? 'PDP' : 'PLP')
      };
      Shopify.analytics.publish('customizer_action', eventData);
    },
    openOnReady: true,
    // optionally open the Customizer UI upon intialization
    onApprove: function () {
      var _onApprove2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                handleApprove(data, initCustObj.quantity, initCustObj);
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function onApprove(_x5) {
        return _onApprove2.apply(this, arguments);
      }
      return onApprove;
    }()
  });
}

/*
|| THE BELOW METHOD IS USED BY EVERY INSTANCE OF THE CUSTOMIZER, BOTH GENERIC AND OFF-SHELF, PDP AND PLP
|| 
|| handleApprove()
||      args: data {Object}, quantity {Number}, initCustObj {Object}
||      The method receives the data response from the customizer api as data argument, quantity from the page's input field (default of 1)
||      and the initCustObj defined in either handleCustomizer(e) or loadOffShelfCustomizer(), this object contains the necessary variant ID
||      for interacting with the Shopify Cart API
||      The method assigns all the required line item properties for orders to be received by MES successfully including serialized data object
*/
function handleApprove(_x6, _x7, _x8) {
  return _handleApprove.apply(this, arguments);
}
function _handleApprove() {
  _handleApprove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(data, quantity, initCustObj) {
    var handle, id, prodVariants, customiserTypeSettings, buildProperties, _buildProperties, properties, formData;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _buildProperties = function _buildProperties3() {
              _buildProperties = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(customizerObject, properties, index) {
                var newHandle, returnedSKU, props, _customizerObject$tex, _customizerObject$tex2, detailsObj, _customizerObject$pre, _customizerObject$pre2, _customizerObject$pre3, _customizerObject$pre4, _customizerObject$pre5, _detailsObj, _customizerObject$aut, _customizerObject$aut2, _detailsObj2, _customizerObject$aut3, _customizerObject$aut4, _detailsObj3;
                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        // Properties object to be included in ATC, this will later include [_customization${index}] with a value of object

                        // Alters the variant ID for ATC in the event colourway was changed IN customiser
                        if (customizerObject.productkey != handle) {
                          newHandle = customizerObject.productkey;
                          returnedSKU = prodVariants.find(function (variant) {
                            return variant.customizer_upk === newHandle;
                          }).variantId;
                          id = returnedSKU;
                        }

                        // props is object to be assigned to [_customization${index}] property
                        props = {};
                        if (customizerObject.customtype == "text") {
                          detailsObj = {
                            "version": customizerObject.version,
                            "customtype": customizerObject.customtype,
                            "location": customizerObject.location,
                            "productkey": customizerObject.productkey,
                            "productsku": customizerObject.productsku,
                            "position": customizerObject.position,
                            "orientation": customizerObject.orientation,
                            "scale": customizerObject.scale,
                            "width": customizerObject.width,
                            "height": customizerObject.height,
                            "embid": customizerObject.embid,
                            "corrid": customizerObject.corrid,
                            "sessionid": customizerObject.sessionid,
                            "svg": customizerObject.svg,
                            "centeroffsety": customizerObject.centeroffsety,
                            "approved": customizerObject.approved,
                            "locale": customizerObject.locale,
                            "custpreview": customizerObject.custpreview,
                            "productpreview": customizerObject.productpreview,
                            "laserimage": customizerObject.laserimage,
                            "sku": customizerObject.sku,
                            "text": customizerObject.text,
                            "warpedpreview": customizerObject.warpedpreview,
                            "agreedtoselfcertify": customizerObject.agreedtoselfcertify
                          };
                          detailsObj = JSON.stringify(detailsObj);
                          props = {
                            type: "text",
                            text: customizerObject.text.htmltext,
                            location: customizerObject.location,
                            _Preview: customizerObject.warpedpreview,
                            _BMP: customizerObject.laserimage,
                            _details: detailsObj,
                            _product_UPK: customizerObject.productkey,
                            _requires_review: !customizerObject.approved,
                            _agreedtoselfcertify: "".concat(customizerObject === null || customizerObject === void 0 ? void 0 : customizerObject.agreedtoselfcertify),
                            _moderationid: "".concat(customizerObject !== null && customizerObject !== void 0 && (_customizerObject$tex = customizerObject.text) !== null && _customizerObject$tex !== void 0 && _customizerObject$tex.moderationid ? customizerObject === null || customizerObject === void 0 ? void 0 : (_customizerObject$tex2 = customizerObject.text) === null || _customizerObject$tex2 === void 0 ? void 0 : _customizerObject$tex2.moderationid : null),
                            _isPremium: 'false'
                          };
                        }
                        if (customizerObject.customtype == "prepared") {
                          _detailsObj = {
                            "version": customizerObject.version,
                            "customtype": customizerObject.customtype,
                            "location": customizerObject.location,
                            "productkey": customizerObject.productkey,
                            "productsku": customizerObject.productsku,
                            "position": customizerObject.position,
                            "orientation": customizerObject.orientation,
                            "scale": customizerObject.scale,
                            "width": customizerObject.width,
                            "height": customizerObject.height,
                            "embid": customizerObject.embid,
                            "corrid": customizerObject.corrid,
                            "sessionid": customizerObject.sessionid,
                            "svg": customizerObject.svg,
                            "centeroffsety": customizerObject.centeroffsety,
                            "approved": customizerObject.approved,
                            "locale": customizerObject.locale,
                            "custpreview": customizerObject.custpreview,
                            "productpreview": customizerObject.productpreview,
                            "laserimage": customizerObject.laserimage,
                            "sku": customizerObject.sku,
                            "image": customizerObject.image,
                            "warpedpreview": customizerObject.warpedpreview,
                            "agreedtoselfcertify": customizerObject.agreedtoselfcertify,
                            "prepared": customizerObject === null || customizerObject === void 0 ? void 0 : customizerObject.prepared
                          };
                          _detailsObj = JSON.stringify(_detailsObj);
                          props = {
                            type: "image",
                            image: customizerObject.custpreview,
                            location: customizerObject.location,
                            _Preview: customizerObject.warpedpreview,
                            _BMP: customizerObject.laserimage,
                            _details: _detailsObj,
                            _product_UPK: customizerObject.productkey,
                            _requires_review: !customizerObject.approved,
                            _moderationid: customizerObject !== null && customizerObject !== void 0 && (_customizerObject$pre = customizerObject.prepared) !== null && _customizerObject$pre !== void 0 && _customizerObject$pre.moderationid ? customizerObject === null || customizerObject === void 0 ? void 0 : (_customizerObject$pre2 = customizerObject.prepared) === null || _customizerObject$pre2 === void 0 ? void 0 : _customizerObject$pre2.moderationid : "null",
                            _agreedtoselfcertify: "".concat(customizerObject === null || customizerObject === void 0 ? void 0 : customizerObject.agreedtoselfcertify),
                            _isPremium: (customizerObject === null || customizerObject === void 0 ? void 0 : (_customizerObject$pre3 = customizerObject.prepared) === null || _customizerObject$pre3 === void 0 ? void 0 : _customizerObject$pre3.premium) !== undefined || (customizerObject === null || customizerObject === void 0 ? void 0 : (_customizerObject$pre4 = customizerObject.prepared) === null || _customizerObject$pre4 === void 0 ? void 0 : _customizerObject$pre4.premium) !== null ? customizerObject === null || customizerObject === void 0 ? void 0 : (_customizerObject$pre5 = customizerObject.prepared) === null || _customizerObject$pre5 === void 0 ? void 0 : _customizerObject$pre5.premium.toString() : 'false'
                          };
                        }
                        if (customizerObject.customtype == "autoimage") {
                          _detailsObj2 = {
                            "version": customizerObject.version,
                            "customtype": customizerObject.customtype,
                            "location": customizerObject.location,
                            "productkey": customizerObject.productkey,
                            "productsku": customizerObject.productsku,
                            "position": customizerObject.position,
                            "orientation": customizerObject.orientation,
                            "scale": customizerObject.scale,
                            "width": customizerObject.width,
                            "height": customizerObject.height,
                            "embid": customizerObject.embid,
                            "corrid": customizerObject.corrid,
                            "sessionid": customizerObject.sessionid,
                            "svg": customizerObject.svg,
                            "centeroffsety": customizerObject.centeroffsety,
                            "approved": customizerObject.approved,
                            "locale": customizerObject.locale,
                            "custpreview": customizerObject.custpreview,
                            "productpreview": customizerObject.productpreview,
                            "laserimage": customizerObject.laserimage,
                            "sku": customizerObject.sku,
                            "text": customizerObject.text,
                            "warpedpreview": customizerObject.warpedpreview,
                            "agreedtoselfcertify": customizerObject.agreedtoselfcertify
                          };
                          _detailsObj2 = JSON.stringify(_detailsObj2);
                          props = {
                            type: "autoimage",
                            location: customizerObject.location,
                            _Preview: customizerObject.warpedpreview,
                            _BMP: customizerObject.laserimage,
                            _details: _detailsObj2,
                            _product_UPK: customizerObject.productkey,
                            _requires_review: !customizerObject.approved,
                            _agreedtoselfcertify: "".concat(customizerObject === null || customizerObject === void 0 ? void 0 : customizerObject.agreedtoselfcertify),
                            _moderationid: "".concat(customizerObject !== null && customizerObject !== void 0 && (_customizerObject$aut = customizerObject.autoimage) !== null && _customizerObject$aut !== void 0 && _customizerObject$aut.moderationid ? customizerObject === null || customizerObject === void 0 ? void 0 : (_customizerObject$aut2 = customizerObject.autoimage) === null || _customizerObject$aut2 === void 0 ? void 0 : _customizerObject$aut2.moderationid : null),
                            _isPremium: 'false'
                          };
                        }
                        if (customizerObject.customtype == 'monogram') {
                          _detailsObj3 = {
                            "version": customizerObject.version,
                            "customtype": customizerObject.customtype,
                            "location": customizerObject.location,
                            "productkey": customizerObject.productkey,
                            "productsku": customizerObject.productsku,
                            "position": customizerObject.position,
                            "orientation": customizerObject.orientation,
                            "scale": customizerObject.scale,
                            "width": customizerObject.width,
                            "height": customizerObject.height,
                            "embid": customizerObject.embid,
                            "corrid": customizerObject.corrid,
                            "sessionid": customizerObject.sessionid,
                            "svg": customizerObject.svg,
                            "centeroffsety": customizerObject.centeroffsety,
                            "approved": customizerObject.approved,
                            "locale": customizerObject.locale,
                            "custpreview": customizerObject.custpreview,
                            "productpreview": customizerObject.productpreview,
                            "laserimage": customizerObject.laserimage,
                            "sku": customizerObject.sku,
                            "image": customizerObject.image,
                            "warpedpreview": customizerObject.warpedpreview,
                            "agreedtoselfcertify": customizerObject.agreedtoselfcertify,
                            "prepared": customizerObject === null || customizerObject === void 0 ? void 0 : customizerObject.prepared
                          };
                          _detailsObj3 = JSON.stringify(_detailsObj3);
                          props = {
                            type: "image",
                            image: customizerObject.custpreview,
                            location: customizerObject.location,
                            _Preview: customizerObject.warpedpreview,
                            _BMP: customizerObject.laserimage,
                            _details: _detailsObj3,
                            _product_UPK: customizerObject.productkey,
                            _requires_review: !customizerObject.approved,
                            _moderationid: customizerObject !== null && customizerObject !== void 0 && (_customizerObject$aut3 = customizerObject.autoimage) !== null && _customizerObject$aut3 !== void 0 && _customizerObject$aut3.moderationid ? customizerObject === null || customizerObject === void 0 ? void 0 : (_customizerObject$aut4 = customizerObject.autoimage) === null || _customizerObject$aut4 === void 0 ? void 0 : _customizerObject$aut4.moderationid : "null",
                            _agreedtoselfcertify: "".concat(customizerObject === null || customizerObject === void 0 ? void 0 : customizerObject.agreedtoselfcertify),
                            _isPremium: 'false'
                          };
                        }

                        // Adds new cust object to indexed customizations property for ATC
                        properties["_customization".concat(index)] = props;
                        return _context7.abrupt("return", properties);
                      case 8:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));
              return _buildProperties.apply(this, arguments);
            };
            buildProperties = function _buildProperties2(_x10, _x11, _x12) {
              return _buildProperties.apply(this, arguments);
            };
            handle = initCustObj.handle, id = initCustObj.id, prodVariants = initCustObj.prodVariants, customiserTypeSettings = initCustObj.customiserTypeSettings; // Gets qty of customized units in cart
            // Function builds properties for given customization, assigns it to an indexed key and returns it
            // Properties variable declared at HOF Scope
            properties = {}; // Loops through array of cust responses to build Customizer Line Item Properties
            properties = {
              _customized: true
            };
            _context8.next = 7;
            return data.forEach( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(cust, index) {
                var _customization$prepar, _customization$prepar2;
                var customization;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        customization = JSON.parse(cust);
                        _context6.next = 3;
                        return buildProperties(customization, properties, index);
                      case 3:
                        properties = _context6.sent;
                        properties["_product_UPK"] = customization.productkey;
                        properties["_isPremium"] = (customization === null || customization === void 0 ? void 0 : (_customization$prepar = customization.prepared) === null || _customization$prepar === void 0 ? void 0 : _customization$prepar.premium) !== undefined ? customization === null || customization === void 0 ? void 0 : (_customization$prepar2 = customization.prepared) === null || _customization$prepar2 === void 0 ? void 0 : _customization$prepar2.premium : false;
                        properties["_preview_".concat(customization.location)] = customization.warpedpreview;
                        if (properties["_customization".concat(index)]["_requires_review"] === true) {
                          properties["_requires_review"] = true;
                        } else if (properties["_customization".concat(index)]["_requires_review"] === false && properties["_requires_review"] === undefined) {
                          properties["_requires_review"] = 'false';
                        }
                      case 8:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));
              return function (_x13, _x14) {
                return _ref2.apply(this, arguments);
              };
            }());
          case 7:
            if (data.length > 1) {
              properties["_engraving_sku"] = "".concat(customiserTypeSettings.frontbackStdChargeSku);
            } else {
              properties["_engraving_sku"] = "".concat(customiserTypeSettings.frontStdChargeSku);
            }
            formData = {
              items: [{
                id: id,
                quantity: quantity,
                properties: properties
              }]
            };
            _context8.next = 11;
            return productForm.callAjaxApi(JSON.stringify(formData));
          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _handleApprove.apply(this, arguments);
}